"use strict";

var _objectWithoutProperties = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.LayoutComponent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/components/Layout.js";
/* eslint-disable no-undef */

var React = require('react');

var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

var Layout = false;

if (typeof TL__GATSBY_LAYOUT_COMPONENT_PATH !== "undefined" && !!TL__GATSBY_LAYOUT_COMPONENT_PATH) {
  try {
    Layout = preferDefault(require(TL__GATSBY_LAYOUT_COMPONENT_PATH));
  } catch (e) {
    if (e.toString().indexOf("Error: Cannot find module") !== -1) {
      throw new Error("Couldn't find layout component at \"".concat(TL__GATSBY_LAYOUT_COMPONENT_PATH, ".\n\n") + "Please create layout component in that location or specify path to layout component in gatsby-config.js");
    } else {
      // Logging the error for debugging older browsers as there is no way
      // to wrap the thrown error in a try/catch.
      console.error(e);
      throw e;
    }
  }
}

var LayoutComponent = function LayoutComponent(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  if (Layout) {
    return /*#__PURE__*/React.createElement(Layout, (0, _extends2.default)({}, props, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 10
      }
    }), children);
  } else {
    return children;
  }
};

exports.LayoutComponent = LayoutComponent;